import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore/lite";
import { EIntegrationPlatform } from "../../models/integrations.model";
import { createIntegration } from "../integrations.service";

export async function authWikipedia({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();
  const uid = localStorage.getItem("uid") || "";
  const queried = query(
    collection(db, "integrations"),
    where("userId", "==", uid),
    where("platform", "==", EIntegrationPlatform.WIKIPEDIA)
  );

  const { docs } = await getDocs(queried);

  const data = docs.map((doc) => ({ ...doc.data(), id: doc.id }));

  if (data.length == 0) {
    return createIntegration({
      onSuccess,
      onError,
      accessToken: "",
      refreshExpireAt: "",
      refreshToken: "",
      platform: EIntegrationPlatform.WIKIPEDIA,
    });
  }

  onSuccess?.(data[0]);
}
